module.exports = __webpack_public_path__ + "img/faq_ladies.5b31c8b1.jpg";